import { schema } from 'normalizr';

const nestedAnswerSchema = new schema.Entity(
  'answers',
  {},
  {
    idAttribute: (answer, question) => question.id,
    processStrategy: answer => answer.value,
  }
);

export const questionSchema = new schema.Entity('questions', {
  answer: nestedAnswerSchema,
});

export const matrixQuestionSchema = new schema.Entity('matrixQuestions', {
  columns: {
    questions: [questionSchema],
  },
  answer: nestedAnswerSchema,
});



// WEBPACK FOOTER //
// ./src/schema/survey/questionSchemas.js